import React from 'react';
import { Link } from 'react-router-dom';

import { pathToUrl } from '../utils/router';
import { PageRoutesEnum } from '../utils/routes';

type LinkCellProps = {
  text: string;
  pageRoute: PageRoutesEnum;
  record: { key: React.Key };
};

export const LinkTableCell: React.FC<LinkCellProps> = ({ text, pageRoute, record }) => {
  return (
    <Link to={pathToUrl(pageRoute, { id: String(record.key) })} style={{ color: 'black' }}>
      <div style={{ width: '100%', padding: '16px' }}>{text}</div>
    </Link>
  );
};
